import { ITheme, IStyle, mergeStyleSets, getTheme, MessageBarType } from '@fluentui/react';
import React, { useMemo } from 'react';
import { IProjectConfiguration } from '../../../../entities-generated/models/project/project-configuration';
import { IDoorInstallationModel } from '../../../../entities-generated/models/project/door-installation-model';
import { where } from '../../../../framework/utils/collection';
import { BwjNote } from '../../../../framework/components/bwj-note';

interface IPriceChangeSummaryProps {
  projectConfig: IProjectConfiguration;
}

const getStyleClasses = (theme: ITheme) => {
  const list: IStyle = {
    paddingInlineStart: '2em',
    margin: 0,
    marginTop: '1em',
  };

  const root: IStyle = {
    margin: 0,
    marginBottom: '2rem',
    padding: 0,

    '& ul': list,
  };

  return mergeStyleSets({
    root,
  });
}

const toPriceChange = (site: string, door: IDoorInstallationModel) => {
  const change = Math.abs(door.priceChange / 100);
  const message = door.priceChange > 0
    ? `<li>The price of <strong>${door.selectedDoor!.brand} ${door.selectedDoor!.description}</strong> (${site}) has increased by <strong>$${change.toFixed(2)}</strong> since you last looked</li>`
    : `<li>The price of <strong>${door.selectedDoor!.brand} ${door.selectedDoor!.description}</strong> (${site}) was lowered by <strong>$${change.toFixed(2)}</strong> since you last looked</li>`;
  return message;
}

export const PriceChangeSummary: React.FunctionComponent<IPriceChangeSummaryProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);
  const { projectConfig } = props;
  const content = useMemo(() => {
    const changes = projectConfig.installLocations
      .map(site => {
        const doors = where(site.doorInstallations, d => d.isExcluded === false && !!d.selectedDoor && d.priceChange !== 0);
        return doors.map(door => { return { site: site.name, door }; });
      })
      .flatMap(x => x)
      .map(doorInfo => toPriceChange(doorInfo.site, doorInfo.door));
    if(changes.length === 0) { return undefined; }

    const declaration = changes.length > 1 
    ? 'There are some price changes that we want you to be aware of:'
    : 'There was price change that we want you to be aware of:';

    return `${declaration} <ul>${changes.join(' ')}</ul>`;
  }, [projectConfig]);

  return (
    <>
    {!!content &&
    <div className={cs.root}>
      <BwjNote
        type={MessageBarType.info}
        textContent={content}
        renderTextAsHtml={true}
      />
    </div>}
    </>
  );
};
